import * as React from "react";
import Box from '../../../parts/Box';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ManualSaveInputButtonContainer from "../../InputPage/containers/SaveInputButtonContainer";

import { ISummaryComponentPropsData, ISummaryComponentPropsFunctions } from "../props/ISummaryComponentProps";
import {IInputComponentPropsData, IInputComponentPropsFunctions} from '../../InputPage/props/IInputComponentProps';
import {IInputJobSettingsPropsData, IInputJobSettingsPropsFunctions} from '../../InputPage/props/IInputJobSettingsProps';
import {Helmet} from "react-helmet";


type IProps =   ISummaryComponentPropsData & ISummaryComponentPropsFunctions & 
                IInputJobSettingsPropsData & IInputJobSettingsPropsFunctions & 
                IInputComponentPropsData & IInputComponentPropsFunctions & 
                { history: any };;
interface IState {
    modal: boolean,
    runJobClicked: boolean,
}

export default class SummaryComponent extends React.Component<IProps, IState> {

    state = {
        modal: false,
        runJobClicked: false,
    }


    
    componentDidMount() {
        if (this.props.noData) {
            // when the user refreshes page, redirect to home
            this.props.goHome();
        }
    }

    toggle = () => {
        this.setState({modal: !this.state.modal});
    }

    showResults = () => {
        this.props.showResults(this.props.exampleJobId);
    }

    handleRunJobClick = () => {
        if (this.props.exampleJobId === null) {
            // run job normally, no modal
            this.runJob();
        } else {
            // open modal
            this.toggle();
        }
    }

    runJob = () => {
        this.setState({runJobClicked: true});
        this.props.runJob(this.props.newJob);
        this.setState({runJobClicked: false});
    }
    
    render() {

        return <div>
            <Helmet>
                <title>Job Summary</title>
            </Helmet>

            <Box title="Job Summary">

                <table className="ll-info-table">
                    <tbody>
                        <tr>
                            <td>Job title:</td>
                            <td>{this.props.jobTitle}</td>
                        </tr>
                        <tr>
                            <td>Email:</td>
                            <td>{this.props.email}</td>
                        </tr>
                        <tr>
                            <td>Sequence:</td>
                            <td style={{maxWidth: "500px", wordWrap: "break-word"}}>{this.props.sequence}</td>
                        </tr>
                    </tbody>
                </table>

            </Box>

            <div className="ll-button-group">
                <Button size="lg" onClick={this.props.goBack}>
                    Back
                </Button>
                <Button
                    color="primary"
                    size="lg"
                    onClick={this.handleRunJobClick}
                    disabled={this.props.disabled || this.state.runJobClicked}
                >
                    Run job
                </Button>
            </div>

            <Modal
                isOpen={this.state.modal}
                centered={true}
                fade={false}
            >
                <ModalHeader toggle={this.toggle}>
                    Example job
                </ModalHeader>
                <ModalBody>
                    You have entered the example input. Would you like to continue to the precomputed results?
                </ModalBody>
                <ModalFooter>
                    <Button onClick={this.toggle}>Cancel</Button>
                    <Button color="primary" onClick={this.showResults}>Yes, show the results</Button>
                </ModalFooter>
            </Modal>
        </div>
    }


}
